export default class IABCategory {
  id: string;

  name: string;

  description: string;

  subCategories?: IABCategory[];

  children?: IABCategory[];

  code?: string;

  parentID: string;

  constructor(id: string, name: string, code: string = null, subCategories: IABCategory[] = []) {
    this.id = id;
    this.name = name;
    this.description = `${this.id} - ${this.name}`;
    this.subCategories = subCategories;

    // Targeting filter
    this.children = subCategories;
    this.code = this.isTopCategory ? id : `${code}.${id}`;
    this.parentID = this.isTopCategory ? null : code;
  }

  get isTopCategory(): boolean {
    return this.id.indexOf('-') === -1;
  }

  copy() {
    return new IABCategory('', null);
  }
}
